import React from "react";
import "./App.css";
import AppRoute from "./routes/AppRoute.tsx";
import { Bounce, ToastContainer } from "react-toastify";

function App() {
  return (
    <div className="App">
      <AppRoute />
      <ToastContainer
        className="toast-style"
        position="top-center"
        autoClose={1000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
        aria-label={undefined}
      />
    </div>
  );
}

export default App;
